export default __webpack_public_path__ + "static/media/14.c0853eb8.JPG";